import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxesStacked } from '@fortawesome/pro-light-svg-icons';
import Flex from 'components/ui/Flex';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Text from 'components/ui/Text';

export const BATCH_RETURN_COLOR = '#FF7F00';
export const BATCH_BP = 1520;

const BatchReturnHome = () => {
    const { t } = useTranslation();

    return (
        <Flex column $grow={1} align="center" justify="center" className="batch-return-home">
            <Heading>{t('batchReturns', 'Batch returns')}</Heading>
            <IconContainer>
                <FontAwesomeIcon icon={faBoxesStacked} size="6x" color={BATCH_RETURN_COLOR} />
            </IconContainer>

            {/* test for the user what to do */}
            <Text as="p" fontSize={16} className="mt-4 text-center">
                {t(
                    'batchReturn.homePageDescription',
                    'Here you can manage your batch returns. Select a status to view the corresponding batch returns.',
                )}
            </Text>
        </Flex>
    );
};

export default BatchReturnHome;

const Heading = styled.h1`
    font-size: 2rem;
    margin-bottom: 1rem;
    color: ${BATCH_RETURN_COLOR};
`;

const IconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 150px;
    height: 150px;
    border-radius: 50%;
    background-color: ${BATCH_RETURN_COLOR}33;
`;
